import {
  faArrowLeftToLine,
  faArrowRightToLine,
} from '@fortawesome/pro-solid-svg-icons';
import Tippy from '@tippyjs/react';
import PropTypes from 'prop-types';
import { animated, useSpring } from 'react-spring';

import { Icon } from '../Icons';

import './styles/globalSecondaryStyles.css';

const GlobalSecondary = ({
  ariaLabel,
  children,
  className,
  isOpen,
  setIsOpen,
}) => {
  const { opacity, width } = useSpring({
    opacity: isOpen ? '1' : '0',
    width: isOpen ? '10.25rem' : '1rem',
    config: {
      mass: 1,
      tension: 210,
      friction: 20,
      clamp: true, // Whether it should ever overshoot the transitions.
    },
  });

  const label = isOpen ? 'Collapse' : 'Expand';

  return (
    <animated.div
      className={`flex relative bg-gray-1 z-navigationToggle ${className}`}
      style={{ width }}
    >
      <div className="z-1 absolute -right-4 top-16">
        <Tippy
          animation="fade"
          arrow
          content={label}
          interactive
          placement="bottom"
        >
          <button
            aria-label={label}
            className="bg-gray-5 h-10 w-10 rounded-full p-0 border-0"
            onClick={() => setIsOpen(!isOpen)}
            type="button"
          >
            <Icon
              className="text-white"
              icon={isOpen ? faArrowLeftToLine : faArrowRightToLine}
              size="lg"
            />
          </button>
        </Tippy>
      </div>
      <animated.nav
        aria-label={ariaLabel}
        className="global-secondary-navigation-container flex flex-col h-screen overflow-x-hidden overflow-y-auto text-center"
        style={{ opacity }}
      >
        <div className="global-secondary-navigation-list">{children}</div>
      </animated.nav>
    </animated.div>
  );
};

GlobalSecondary.defaultProps = {
  className: '',
  isOpen: true,
};

GlobalSecondary.propTypes = {
  /**
   * ARIA label for the overall navigation
   */
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  /**
   * Any custom CSS classes to add to the navigation
   */
  className: PropTypes.string,
  /**
   * Set open state
   */
  isOpen: PropTypes.bool,
  /**
   * Set function that will control open state
   */
  setIsOpen: PropTypes.func.isRequired,
};

export default GlobalSecondary;
